<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          btnTitle="List"
          :showBtn="true"
          :showAddNew="false"
          :title="(budgetId ? 'Edit' : 'Add New') + ' Budget'"
          @onClickCloseButton="navigateToListPage"
      />

      <div class="row mt-2 gy-1">
        <div class="row mt-1">
          <div class="col-sm-3">
            <label class="align-middle">Project</label>
            <v-select
              placeholder="Select Project"
              v-model="formData.project_master_id"
              :options="projects"
              label="name"
              :reduce="name => name.id"
              @option:selected="onProjectSelected"
            />
          </div>
          <div class="col-sm-3">
            <label class="align-middle">Interval</label>
            <input type="text" class="form-control disabled" name="interval" :value="projectInterval?.name" disabled/>
          </div>
          <div class="col-sm-3">
            <label class="align-middle">Start Date</label>
            <input type="date" class="form-control disabled" :value="selectedProject?.start_date" disabled>
          </div>
          <div class="col-sm-3">
            <label class="align-middle">End Date</label>
            <input type="date" class="form-control disabled" :value="selectedProject?.end_date" disabled>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-sm-6">
            <label class="align-middle">Budget Name</label>
            <input
                placeholder="Budget name"
                v-model="formData.name"
                class="form-control"
            />
          </div>
          <div class="col-sm-3">
            <label class="align-middle">Budget Code</label>
            <input type="text" class="form-control" v-model="formData.code">
          </div>
          <div class="col-sm-3">
            <label class="align-middle">Create Date</label>
            <input type="date" class="form-control" v-model="formData.create_date">
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-sm-6">
            <label class="align-middle">Business</label>
            <v-select
                placeholder="Select Business"
                v-model="formData.business_id"
                :options="businesses"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-sm-3">
            <label class="align-middle">Cost Centre</label>
            <v-select
                placeholder="Select Cost Centre"
                v-model="formData.cost_centre_id"
                :options="costCentres"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-sm-3">
            <label class="align-middle">Party</label>
            <AsyncSelect
                placeholder="Select Party"
                v-model="formData.party_id"
                :api-service="fetchParties"
                label="name"
                :reduce="name => name.id"
                :additional-option="partyOptions"
            />
          </div>
          <div class="col-sm-3" v-if="budgetId">
            <label class="align-middle">Status</label>
            <v-select
                placeholder="Select Status"
                v-model="formData.status"
                :options="statusList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white p-1" v-show="budgetId">

      <AccountTree
          :key="tab + treeKey"
          :groupData="projectAccountList.group"
          :endpointData="projectAccountList.endpoint"
          :accountType="tab"
          :tabs="tabs"
          :isExporting="headSheet.isExporting"
          @handleTabChange="handleTabChange"
          @handleRootPagination="getAccountTree"
          @handleExport="exportHeadSheet"
          @handleImport="openHeadSheetModal"
      />
    </div>

    <div class="bg-blue-light p-1">
      <div class="mt-2">
        <div class="d-flex flex-wrap gap-1 gy-2 justify-content-center">
          <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(true)"
                  class="btn btn-primary">
            Save
          </button>
          <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(false)"
                  class="btn btn-primary">Save & New
          </button>
          <button @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
        </div>
      </div>
    </div>

    <GlobalLoader/>

    <BudgetGeneralModal
        ref="budgetGeneralModal"
        :key="budgetGeneralForm.project_account_id"
        :form="budgetGeneralForm"
        :accountType="tab"
        @onBusinessGeneralSave="handleBudgetGeneral"
        @onResetBreakdown="getBudgetInterval"
    />

    <BudgetHeadSheetModal
        ref="budgetHeadSheetModal"
        :sheet="headSheet"
    />

  </div>
</template>
<script setup>
import {computed, inject, onMounted, onUnmounted, reactive, ref} from 'vue'
import {useRoute, useRouter} from "vue-router";
import TitleButton from '@/components/atom/TitleButton'
import handleProjects from "@/services/modules/procurement/project";
import loader from "@/components/atom/loader/Loader";
import handleBudgets from "@/services/modules/procurement/budget";
import AccountTree from "@/components/molecule/procurement/budget/AccountTree";
import BudgetGeneralModal from "@/components/molecule/procurement/budget/BudgetGeneralModal";
import handleDropdowns from "@/services/modules/dropdowns";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import BudgetHeadSheetModal from "@/components/molecule/procurement/budget/head-sheet/BudgetHeadSheetModal.vue";
import useBudgetHeadSheet from "@/composables/useBudgetHeadSheet";

const router = useRouter()
const route = useRoute()
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const emitter = inject('emitter');
const {fetchParties} = handleProjects();
const {
  createNewBudget,
  updateBudget,
  fetchAccountTree,
  fetchBudgetAccountTree,
  fetchBudget,
  fetchBudgetGeneral,
  fetchAccount,
  storeBudgetGeneral,
  updateBudgetGeneral,
  fetchNewBudgetInterval,
} = handleBudgets();
const { fetchDropdownList } = handleDropdowns();

let budgetGeneralModal = ref(null)
let budgetHeadSheetModal = ref(null)
const headSheet = reactive(useBudgetHeadSheet(
    () => budgetId.value,
    () => getQuery(),
    () => formData.value.name,
    () => currentTab.value,
    () => refreshAfterImport()
));
let saveButtonLoader = ref(false)
let saveNewButtonLoader = ref(false)
let tab = ref('item');
let homeContent = ref({});
let businesses = ref([])
let projects = ref([])
let costCentres = ref([])
let selectedProject = ref({});
let projectAccountList = ref({
  group: [],
  endpoint: {}
})
let treeKey = ref(0);

let formData = ref({
  business_id: null,
  cost_centre_id: null,
  project_master_id: null,
  party_id: null,
  name: null,
  code: null,
  create_date: null,
  status: 'active',
})
let budgetGeneralForm = ref({
  'budget_master_id': '',
  'project_account_id': '',
  'project_account_name': '',
  'quantity': '',
  'rate': '',
  'amount': '',
  'fill_type': 'fill',
});

function navigateToListPage() {
  route.params.budgetId = null;
  router.push({name: `project-budget-list`, params: route.params, query: route.query});
}

function handleSubmit(redirect = false) {
  if (redirect) {
    saveButtonLoader.value = true
  } else {
    saveNewButtonLoader.value = true
  }

  if(selectedProject.value.interval === null) {
    showError('Please update project with interval');
    saveButtonLoader.value = false;
    saveNewButtonLoader.value = false;
    return;
  }

  let res = null;
  if (budgetId.value) {
    res = updateBudget(budgetId.value, formData.value, getQuery());
  } else {
    res = createNewBudget(formData.value, getQuery());
  }

  res.then(response => {
    saveButtonLoader.value = false
    saveNewButtonLoader.value = false

    if (response.status) {
      showSuccess(response.message)
      if (tabs.value.length > 0) {
        tab.value = tabs.value[0].id;
      }
      router.push({name: `project-budget-edit`, params: {...route.params, budgetId: response.data.id}, query: route.query});
      getAccountTree();
    }
    if (!response.status) {
      showError(response.message)
    }
  }).catch(err => {
    saveButtonLoader.value = false;
    saveNewButtonLoader.value = false;
  })
}

function resetForm() {
  formData.value = {
    business_id: null,
    cost_centre_id: null,
    project_master_id: null,
    party_id: null,
    name: null,
    code: null,
    create_date: null,
    start_date: null,
    end_date: null,
    interval: null,
  }
}

function getQuery() {
  let query = `?company_id=${route.params.companyId}`;

  if (!tab.value) {
    return query;
  }

  if (tab.value === 'activity_target') {
    return query + `&account_type=activity&project_type=task,donor_kpi`;
  }

  if (tab.value === 'activity_budget') {
    return query + `&account_type=activity`;
  }

  return query + `&account_type=${tab.value.toLowerCase()}`;
}

function showBudgetGeneralModal() {
  if(budgetGeneralModal.value !== null)
    budgetGeneralModal.value.openModal();
}

function handleTabChange(tabName = 'item') {
  tab.value = tabName;
  getAccountTree();
}

function exportHeadSheet() {
  if (selectedProject.value.interval === null) {
    showError('Please update project with interval');
    return;
  }

  headSheet.exportSheet();
}

function openHeadSheetModal() {
  if (selectedProject.value.interval === null) {
    showError('Please update project with interval');
    return;
  }

  budgetHeadSheetModal.value.openModal();
}

async function refreshAfterImport() {
  await getAccountTree();
  treeKey.value++;
}

function onProjectSelected() {
  if(formData.value.project_master_id !== null) {
    let project = projects.value.filter( (project) => {
      return (project.id === formData.value.project_master_id)
    })
    selectedProject.value = project[0] ?? {}
    return;
  } 
  
  selectedProject.value = {};
}

async function getBudget() {
  if (!budgetId.value) {
    return;
  }
  const res = await fetchBudget(budgetId.value, getQuery());
  if (!res.status) {
    showError(res.message);
    return;
  } 
  
  formData.value = res.data;
}

async function getAccountTree(page = 1) {
  if (!budgetId.value) {
    return;
  }

  const query = getQuery() + `&page=${page}&offset=10`;
  const res = await fetchBudgetAccountTree(budgetId.value, query);

  if (res.status && res.data) {
    if (page === 1) {
      projectAccountList.value.group = res.data.group;
    }
    projectAccountList.value.endpoint = res.data.endpoint;
    setPagination(res.data.endpoint);
  }
}

function setPagination(data) {
  emitter.emit('setPaginationData', {
    data: {
      records: data.total,
      perPage: data.per_page,
      currentPage: data.current_page,
    },
    stateName: 'pagination_node_root'
  });
}


async function getBudgetGeneral(accountId, budgetGeneral = null) {
  budgetGeneralForm.value = {
    'budget_master_id': '',
    'project_account_id': '',
    'project_account_name': '',
    'quantity': '',
    'rate': '',
    'amount': '',
    'fill_type': 'fill',
  };
  let res = null;
  let query = getQuery();
  if (budgetGeneral) {
    res = await fetchBudgetGeneral(budgetId.value, budgetGeneral, query);
  } else {
    res = await fetchAccount(budgetId.value, accountId, query);
  }
  if (res.status) {
    budgetGeneralForm.value = {...res.data};
  }
}

const statusList = computed(() => {
  const allowedStatuses = ['active', 'inactive', 'completed'];
  const list = [];

  if (homeContent.value.hasOwnProperty('status')) {
    Object.keys(homeContent.value.status).forEach(id => {
      if (allowedStatuses.includes(id)) {
        list.push({
          id: id,
          name: homeContent.value.status[id],
        });
      }
    });
  }

  return list;
});

const tabs = computed(() => {
  let tabs = [];

  if (!homeContent.value.project_account_type) {
    return tabs;
  }

  Object.keys(homeContent.value.project_account_type).forEach(key => {
    if (key === 'activity') {
      tabs.push({ id: 'activity_budget', name: 'Activity Budget' });
      tabs.push({ id: 'activity_target', name: 'Activity Target' });
      return;
    }
    tabs.push({ id: key, name: homeContent.value.project_account_type[key] });
  });

  return tabs;
});

const currentTab = computed(() => {
  const found = tabs.value.find(item => item.id === tab.value);

  if (! found) return { id: tab.value, name: tab.value };

  return found;
});

async function handleBudgetGeneral(generalId = null) {
  let res = null;

  if (generalId) {
    res = await updateBudgetGeneral(budgetId.value, generalId, budgetGeneralForm.value, getQuery());
  } else {
    res = await storeBudgetGeneral(budgetId.value, budgetGeneralForm.value, getQuery());
  }

  if (res.status) {
    showSuccess(res.message);
    await getAccountTree();
    treeKey.value++;
    emitter.emit('onBudgetGeneralUpdate', {
      eventName: 'onBudgetGeneralUpdate',
      title: 'Update budget general'
    })
    budgetGeneralModal.value.closeModal();
  }
}

const getBudgetInterval = (data) => {
  fetchNewBudgetInterval(data, getQuery())
    .then( res => {
      if(res.status) {
        budgetGeneralForm.value.breakdown = res.data;
        budgetGeneralForm.value.breakdown_qty = {...res.data};
        return;
      } 
      
      showError(res.message);
    })
    .catch( err => {
      showError('Something went wrong please try again.')
    });
}

const intervals = computed(() => {
  let intervals = [];
  if(homeContent.value.hasOwnProperty('project_intervals')) {
    Object.keys(homeContent.value.project_intervals).forEach( id => {
      intervals.push({
        id: id,
        name: homeContent.value.project_intervals[id],
      })
    })
  }
  return intervals;
})

const budgetId = computed(() => {
  return route.params.budgetId ? route.params.budgetId : '';
});

const projectInterval = computed( () => {
  return intervals.value.filter( interval => {
    return (interval.id === selectedProject.value?.interval)
  })[0] ?? {};
})

const partyOptions = computed(() => {
  if (formData.value.party && formData.value.party.id) {
    return [
      {
        id: formData.value.party.id,
        name: formData.value.party.name
      }
    ]
  }
  return []
})

onMounted(async () => {
  loader.value = true;
  const companyId = route.params.companyId;
  const consolidatedQuery = `?company_id=${companyId}&is_business=1&is_cost_centre=1&is_project=1&is_home=1&time_and_interval=1`;

  await fetchDropdownList(consolidatedQuery).then(async (res) => {
    if (res.status && res.data) {
      homeContent.value = res.data.home_data;
      businesses.value = res.data.business_list;
      costCentres.value = res.data.cost_centre_list;
      projects.value = res.data.project_list;
      
      if (tabs.value.length > 0) {
        tab.value = tabs.value[0].id;
      }

      await getBudget();
      selectedProject.value = projects.value.filter((project) => {
        return (project.id === formData.value.project_master_id)
      })[0] ?? {};

      await getAccountTree();
    }
  }).catch((err) => {
    console.error(err);
  }).finally(() => {
    loader.value = false;
  });
})

emitter.off('onBudgetGeneralEdit');
emitter.on('onBudgetGeneralEdit', async ({data}) => {
  await getBudgetGeneral(data.data.id, data.budgetGeneral?.id);
  showBudgetGeneralModal();
});
</script>